import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextInputTypeToken, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import { BavVerifyManualAction, ChangeBankGoBackAction, GoNext, GoToStepper, moveToBankScreen, NavigationSearchIFSCAction, needHelp, onChangeAccountNumber, onChangeIFSCNumber, skipBank, ToggleCTA, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { getBankDefaultPng, getBankPNGUrl } from '../../../configs/utils';
export const template = (bankCode, bankName, accountNumber, ifscValue, userName, height, isFromJupiter) => ({
    layout: {
        id: ROUTE.BANK_ACCOUNT_ADD,
        type: LAYOUTS.LIST,
        widgets: [
            { id: 'st', type: WIDGET.BANK_ADD_PAGE }
        ],
    },
    datastore: {
        st: {
            bankData: {},
            bankCode: bankCode,
            bankName: bankName,
            userName: userName,
            ifscValue: ifscValue,
            height: height,
            sharedPropService: SharedPropsService,
            addBankAction: {
                type: ACTION.CHANGE_BANK_GO_BACK,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
            },
            profileAction: {
                type: ACTION.NAVIGATION_SEARCH_IFSC,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {
                    bankCode: bankCode,
                    bankName,
                },
            },
            moveToBankAddScreen: {
                type: ACTION.GO_TO_BANK_ACCOUNT_ADD,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {}
            },
            applyAction: {
                type: ACTION.TRIGGER_CTA,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {
                    applicationId: '',
                },
            },
            skipBankAction: {
                type: ACTION.SKIP_BANK,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {
                    applicationId: '',
                },
            },
            backAction: {
                type: ACTION.CHANGE_BANK_GO_BACK,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
            },
            continuePress: {
                type: ACTION.GO_TO_NEXT,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
            },
            loading: false,
            isFromJupiter: isFromJupiter
        },
        space1: { size: SizeTypeTokens.XXXL },
        header: {
            isBackButton: true,
            type: HeaderTypeTokens.DEFAULT,
            title: 'Enter account details',
            action: {
                type: ACTION.CHANGE_BANK_GO_BACK,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {},
            },
        },
        cardStack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'stack', type: WIDGET.STACK },
                { id: 'trailIcon', type: WIDGET.ICON },
            ],
        },
        stack: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                { id: 'leadIcon', type: WIDGET.IMAGE },
                { id: 'leadIconSpace', type: WIDGET.SPACE },
                { id: 'bankName', type: WIDGET.TEXT },
            ],
        },
        leadIcon: {
            uri: getBankPNGUrl(bankCode),
            defaultUri: getBankDefaultPng(),
            size: ImageSizeTokens.MD,
            padding: SizeTypeTokens.NONE,
        },
        leadIconSpace: { size: SizeTypeTokens.LG },
        bankName: {
            label: bankName,
            color: ColorTokens.Grey_Night,
            fontSize: FontSizeTokens.XL,
            fontWeight: '600',
        },
        trailIcon: {
            name: IconTokens.Edit,
            size: IconSizeTokens.XXL,
            action: {
                type: ACTION.CHANGE_BANK_GO_BACK,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {},
            },
        },
        accountSpace: { size: SizeTypeTokens.XXXL },
        accountInput: {
            isFocus: true,
            type: InputTypeToken.DEFAULT,
            title: 'Account number',
            placeholder: 'Enter account number',
            value: `${accountNumber}`,
            caption: { success: '', error: '' },
            keyboardType: KeyboardTypeToken.email,
            action: {
                type: ACTION.ONCHANGE_ACCOUNT_NUMBER,
                payload: { value: accountNumber },
                routeId: ROUTE.BANK_ACCOUNT_ADD,
            },
        },
        IFSCSpace: { size: SizeTypeTokens.XXXL },
        IFSCInputStack: {
            width: StackWidth.FULL,
            type: StackType.column,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.center,
            widgetItems: [{ id: 'IFSCInput', type: WIDGET.INPUT }],
            action: {
                type: ACTION.NAVIGATION_SEARCH_IFSC,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {
                    bankCode: bankCode,
                    bankName,
                },
            },
        },
        IFSCInput: {
            isFocus: true,
            type: InputTypeToken.DEFAULT,
            state: InputStateToken.DISABLED,
            title: 'Branch or IFSC',
            placeholder: 'Search by branch or IFSC',
            keyboardType: KeyboardTypeToken.email,
            value: '',
            caption: { success: '', error: '' },
            width: TextInputTypeToken.FULL,
            action: {
                type: ACTION.ONCHANGE_IFSC_NUMBER,
                payload: { value: '' },
                routeId: ROUTE.BANK_ACCOUNT_ADD,
            },
            onPressAction: {
                type: ACTION.NAVIGATION_SEARCH_IFSC,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {
                    bankCode: bankCode,
                    bankName,
                },
            },
        },
        continue: {
            label: 'Verify bank',
            type: ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.TRIGGER_CTA,
                routeId: ROUTE.BANK_ACCOUNT_ADD,
                payload: {
                    applicationId: '',
                },
            },
        },
    },
});
export const bankAccountAddMF = {
    onLoad: async ({ getHeight, setDatastore, instrumentTrack, navigate }, { bankCode, bankName }) => {
        instrumentTrack('VERIFY_BANK_ADD_ACCOUNT_BUTTON_CLICKED');
        console.warn("ON LOAD CALLED $$$$$$$$$$");
        const userName = (await SharedPropsService.getUser())
            .user.fullName;
        console.warn("USER NAME RECEIVED IS", userName);
        const accountNumber = await SharedPropsService.getAccountNumber();
        const ifscValue = await SharedPropsService.getIfsc();
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        return Promise.resolve(template(bankCode, bankName, accountNumber, ifscValue, userName, getHeight(), isFromJupiter));
    },
    actions: {
        [ACTION.NAVIGATION_SEARCH_IFSC]: NavigationSearchIFSCAction,
        [ACTION.ONCHANGE_ACCOUNT_NUMBER]: onChangeAccountNumber,
        [ACTION.ONCHANGE_IFSC_NUMBER]: onChangeIFSCNumber,
        [ACTION.TOGGLE_CTA]: ToggleCTA,
        [ACTION.TRIGGER_CTA]: BavVerifyManualAction,
        [ACTION.CHANGE_BANK_GO_BACK]: ChangeBankGoBackAction,
        [ACTION.NAV_STEPPER]: GoToStepper,
        [ACTION.SKIP_BANK]: skipBank,
        [ACTION.GO_TO_NEXT]: GoNext,
        [ACTION.GO_TO_BANK_ACCOUNT_ADD]: moveToBankScreen,
        [ACTION.NEED_HELP]: needHelp,
    },
    clearPrevious: true,
};
